const CategoriesApi = {
  base: '/categories',
};

export default CategoriesApi;
